"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        tab: __assign(__assign({}, theme_1.default.fonts.headline2), { minWidth: 20, padding: '4px 0px', marginLeft: 32, '&:first-child': {
                marginLeft: 0,
            }, minHeight: 28, color: theme_1.default.textColors.primary }),
        tabSelected: {
            color: theme_1.default.textColors.highlight,
        },
        tabBar: {
            height: 30,
            minHeight: 0,
            maxWidth: '100%',
            paddingRight: 40,
            overflow: 'visible',
        },
        indicator: {
            display: 'flex',
            justifyContent: 'center',
            width: 'auto',
            backgroundColor: theme_1.default.colors.primary,
            height: 4,
            borderRadius: 4,
        },
        wrapper: {
            display: 'inline-flex',
            flexDirection: 'row-reverse',
            justifyItems: 'center',
            alignItems: 'center',
            '&>:first-child': {
                marginBottom: '0px !important',
                marginLeft: 8,
            },
            height: 20,
        },
    });
});
